import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

/* ---------------- MOCK DATA & API ------------------ */
let mockTimetables = [
  { id: 1, name: 'Time Table List 1', startTime: '9:00 AM', endTime: '6:00 PM', },
  { id: 2, name: 'Time Table List 2', startTime: '9:00 AM', endTime: '6:00 PM', },
  { id: 3, name: 'Time Table List 3', startTime: '9:00 AM', endTime: '6:00 PM', },
  { id: 4, name: 'Time Table List 4', startTime: '9:00 AM', endTime: '6:00 PM', },
  { id: 5, name: 'Time Table List 5', startTime: '9:00 AM', endTime: '6:00 PM', },
  { id: 6, name: 'Time Table List 6', startTime: '9:00 AM', endTime: '6:00 PM', },
  { id: 7, name: 'Time Table List 7', startTime: '9:00 AM', endTime: '6:00 PM', },
  { id: 8, name: 'Time Table List 7', startTime: '9:00 AM', endTime: '6:00 PM', },
  { id: 9, name: 'Time Table List 7', startTime: '9:00 AM', endTime: '6:00 PM', },
  { id: 10, name: 'Time Table List 7', startTime: '9:00 AM', endTime: '6:00 PM', },
  { id: 11, name: 'Time Table List 7', startTime: '9:00 AM', endTime: '6:00 PM', },
  { id: 12, name: 'Time Table List 7', startTime: '9:00 AM', endTime: '6:00 PM', },
];
let timetableIdCounter = mockTimetables.length + 1;

export const TimetableAPI = {
  getAll: async () =>
    new Promise((resolve) =>
      setTimeout(() => resolve({ data: { data: [...mockTimetables] } }), 300)
    ),

  add: async (row) =>
    new Promise((resolve) =>
      setTimeout(() => {
        const newRow = { ...row, id: timetableIdCounter++ };
        mockTimetables = [...mockTimetables, newRow];
        resolve({ data: { data: newRow } });
      }, 300)
    ),

  update: async (id, updated) =>
    new Promise((resolve) =>
      setTimeout(() => {
        const i = mockTimetables.findIndex((t) => t.id === id);
        if (i !== -1) mockTimetables[i] = { ...mockTimetables[i], ...updated };
        resolve({ data: { data: mockTimetables[i] } });
      }, 300)
    ),

  delete: async (ids) =>
    new Promise((resolve) =>
      setTimeout(() => {
        const idsArr = Array.isArray(ids) ? ids : [ids];
        mockTimetables = mockTimetables.filter((t) => !idsArr.includes(t.id));
        resolve({ status: 200, data: { deletedCount: idsArr.length, deletedIds: idsArr } });
      }, 300)
    ),
};

/* ---------------- THUNKS ------------------ */
export const fetchTimetables = createAsyncThunk(
  'timetable/fetchTimetables',
  async (_, thunkAPI) => {
    try {
      const res = await TimetableAPI.getAll();
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const addTimetable = createAsyncThunk(
  'timetable/addTimetable',
  async (payload, thunkAPI) => {
    try {
      const res = await TimetableAPI.add(payload);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const updateTimetable = createAsyncThunk(
  'timetable/updateTimetable',
  async (payload, thunkAPI) => {
    try {
      const res = await TimetableAPI.update(payload.id, payload);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const deleteTimetable = createAsyncThunk(
  'timetable/deleteTimetable',
  async (ids, thunkAPI) => {
    try {
      await TimetableAPI.delete(ids);
      return ids;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

/* ---------------- SLICE ------------------ */
const initialState = {
  list: [],
  loading: false,
  error: '',
};

const timetableSlice = createSlice({
  name: 'timetable',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTimetables.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchTimetables.fulfilled, (state, action) => {
        state.loading = false;
        state.list = [...action.payload];
      })
      .addCase(fetchTimetables.rejected, (state, action) => {
        state.loading = false;
        state.list = [];
        state.error = action.payload || 'Failed to load timetables';
      })
      .addCase(addTimetable.fulfilled, (state, action) => {
        state.list.unshift(action.payload);
      })
      .addCase(updateTimetable.fulfilled, (state, action) => {
        const i = state.list.findIndex((t) => t.id === action.payload.id);
        if (i !== -1) state.list[i] = action.payload;
      })
      .addCase(deleteTimetable.fulfilled, (state, action) => {
        const idsArr = Array.isArray(action.payload) ? action.payload : [action.payload];
        state.list = state.list.filter((t) => !idsArr.includes(t.id));
      });
  },
});

export default timetableSlice.reducer;
